import api from '../api'

export default {
    getFilters(data) {
        return api.get("/filters", data);
    },
    getFilter(data) {
        return api.get("/filter", data);
    },
    getData(data) {
        return api.get("/products", data);
    },
    getProducts(data) {
        return api.get("/products", data);
    },
    getProduct(id) {
        return api.get("/product/" + id);
    },
}